import config from "config"
import { getParameterByName } from "."
import { version } from '../../../package.json' // Not to purty...

config.version = version

export default async function ConfigBridge() {
  const onReject = () => false

  config.GAME_CONFIG.BASEGAME_ID = config.GAME_CONFIG.GAME_ID
  const gameid = getParameterByName('gameid')
  if (gameid) { config.GAME_CONFIG.GAME_ID = gameid }

  const translationContext = getParameterByName('translationContext')
  if (translationContext) { config.GAME_CONFIG.translationContext = translationContext }

  let clientconfigurl = getParameterByName('configurl')

  if (!clientconfigurl) {
    const cdnConfigUrl = `${location.protocol}//${location.host}/casino/cdnconfig.json`
    const cdnConfig = await fetch(cdnConfigUrl).then(res => res.json(), onReject).catch(onReject)

    if (!cdnConfig || !cdnConfig.clientconfigurl) { return }

    clientconfigurl = cdnConfig.clientconfigurl
  }

  const jurisdiction = getParameterByName('jurisdiction') || getParameterByName('market')
  const jdQuery = jurisdiction ? `&jurisdiction=${jurisdiction}` : ''
  const pQuery = `&partnerid=${getParameterByName('partnerid') || '1'}`
  const vQuery = version ? `&versionstring=${version}` : ''
  const gameId = config.GAME_CONFIG.GAME_ID || ''
  let configParams = ""

  if (config.configAPIparams) {
    const params = config.configAPIparams
    const ret = []
    Object.keys(params).forEach(param => {
      if (params.hasOwnProperty(param)) {
        ret.push(`&${param}=${params[param]}`)
      }
    })
    configParams = ret.join('')
  }

  const configUrl = `${clientconfigurl}?gameref=${gameId}${jdQuery}${pQuery}${vQuery}${configParams}`
  const apiResponse = await fetch(configUrl).then(res => res.json(), onReject).catch(onReject)

  if (apiResponse && apiResponse.errorCode && apiResponse.errorCode === 524) {
    window.__VERSIONBLOCKED__ = true
  } else if (!apiResponse) { return }

  config.apiResponse = apiResponse

  Object.keys(apiResponse).forEach(key => config[key] = apiResponse[key])

  config.SERVER_CONFIG.SERVER_URL = apiResponse.gameServerApi

  config.JURISDICTION_CONFIG.spinDelay = apiResponse.minSpinTime

  config.FEATURE_CONFIG.QUICKSPIN = apiResponse.quickStop

  config.SERVER_CONFIG.REPLAY_URL = apiResponse.replayApi

  config.SERVER_CONFIG.TOKEN_URL = apiResponse.tokenApi

  config.hideHomeButton = getParameterByName('hidehome') === 'true'
}
